export default __webpack_public_path__ + "static/flux-28527312209a44dddd42f02aadf1c028.svg";